import { produce } from "immer";
import {
  FETCH_EMPLOYEE,
  FETCH_EMPLOYEE_SUCCESS,
  FETCH_EMPLOYEE_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_EMPLOYEE,
  ADD_EMPLOYEE_SUCCESS,
  ADD_EMPLOYEE_FAILURE,
  //
  EDIT_EMPLOYEE,
  EDIT_EMPLOYEE_SUCCESS,
  EDIT_EMPLOYEE_FAILURE,
  //
  DELETE_EMPLOYEE,
  DELETE_EMPLOYEE_SUCCESS,
  DELETE_EMPLOYEE_FAILURE,
  //
  DEFAULT_PERMS,
  SET_CURRENT_PERMS,
  //
  SEARCH_EMPLOYEE,
  SEARCH_EMPLOYEE_SUCCESS,
  SEARCH_EMPLOYEE_FAILURE,
  //
  SAVE_INFO,
  SAVE_INFO_SUCCESS,
  SAVE_INFO_FAILURE,
  //
  SAVE_DOCS,
  SAVE_DOCS_SUCCESS,
  SAVE_DOCS_FAILURE,
  //
  SAVE_SCHEDULE,
  SAVE_SCHEDULE_SUCCESS,
  SAVE_SCHEDULE_FAILURE,
  //
  SEND_INVITE,
  SEND_INVITE_SUCCESS,
  SEND_INVITE_FAILURE,
  //
  TOGGLE_PIN_MODAL,
  //
  SAVE_PROFILE,
  SAVE_PROFILE_FAILURE,
  SAVE_PROFILE_SUCCESS,
  TOGGLE_DOC_MODAL,
  //
  SAVE_PAYROLL,
  SAVE_PAYROLL_SUCCESS,
  SAVE_PAYROLL_FAILURE,
  //
  DELETE_DOC,
  DELETE_DOC_SUCCESS,
  DELETE_DOC_FAILURE,
  //
  SAVE_PIN,
  SAVE_PIN_SUCCESS,
  SAVE_PIN_FAILURE,
  //
  TOGGLE_MAIL_MODAL,
  //
  SEND_MAIL,
  SEND_MAIL_SUCCESS,
  SEND_MAIL_FAILURE,
  //
  UPLOAD_CSV,
  UPLOAD_CSV_SUCCESS,
  UPLOAD_CSV_FAILURE,
  //
  SEARCH_MANAGER,
  SEARCH_MANAGER_SUCCESS,
  SEARCH_MANAGER_FAILURE,
  //
  TOGGLE_IMAGE_MODAL,
  //
  IMPORT_CSV,
  IMPORT_CSV_SUCCESS,
  IMPORT_CSV_FAILURE,
  ANALYZE_EMPLOYEE_AI_IMPORT,
  ANALYZE_EMPLOYEE_AI_IMPORT_SUCCESS,
  ANALYZE_EMPLOYEE_AI_IMPORT_FAILURE,
  MAP_EMPLOYEE_AI_IMPORT,
  MAP_EMPLOYEE_AI_IMPORT_SUCCESS,
  MAP_EMPLOYEE_AI_IMPORT_FAILURE,
  FETCH_EMPLOYEE_AI_IMPORT_SUCCESS,
  DISCARD_EMPLOYEE_AI_IMPORT_SUCCESS,
  //
  TOGGLE_LEAVE_CALC,
  //
  GET_EMP_HISTORY,
  GET_EMP_HISTORY_SUCCESS,
  GET_EMP_HISTORY_FAILURE,
  //
  TOGGLE_HISTORY_MODAL,
  //
  GET_BIRTHDAYS,
  GET_BIRTHDAYS_SUCCESS,
  GET_BIRTHDAYS_FAILURE,
  //
  GET_EXPIRING_DOCS,
  GET_EXPIRING_DOCS_SUCCESS,
  GET_EXPIRING_DOCS_FAILURE,
  //
  GET_EMPTY_SHIFTS,
  GET_EMPTY_SHIFTS_SUCCESS,
  GET_EMPTY_SHIFTS_FAILURE,
  //
  GET_EMPTY_CLOCKS,
  GET_EMPTY_CLOCKS_SUCCESS,
  GET_EMPTY_CLOCKS_FAILURE,
  //
  SEARCH_ROTA_EMPLOYEE,
  SEARCH_ROTA_EMPLOYEE_SUCCESS,
  SEARCH_ROTA_EMPLOYEE_FAILURE,
  //
  TOGGLE_ONBOARDING_MODAL,
  //
  GET_MATRIX,
  GET_MATRIX_SUCCESS,
  GET_MATRIX_FAILURE,
  //
  SET_MATRIX_STEPS,
  TOGGLE_MATRIX_MODAL,
  //
  GET_MATRIX_STATS,
  GET_MATRIX_STATS_SUCCESS,
  GET_MATRIX_STATS_FAILURE,
  //
  DELETE_DOC_VERSION,
  DELETE_DOC_VERSION_SUCCESS,
  DELETE_DOC_VERSION_FAILURE,
  //
  GET_EMP_INDICATORS,
  GET_EMP_INDICATORS_SUCCESS,
  GET_EMP_INDICATORS_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingEmployee: false,
  employeeList: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentEmployee: {},
  // Delete
  isDeleting: false,
  defaultPerms: [],
  currentPerms: [],
  //
  isSearchingEmployee: false,
  searchEmpList: [],
  //
  isSavingDocs: false,
  isUpdatingSchedule: false,
  //
  isSendingInvite: false,
  //
  pinModal: {
    open: false,
  },
  isSavingProfile: false,
  docModal: {
    open: false,
  },
  //
  isSavingPayroll: false,
  isDeletingDoc: false,
  //
  isSavingPin: false,
  mailModal: {
    open: false,
    data: {},
  },
  isSendingMail: false,
  isUploadingCSV: false,
  csvErrors: [],
  csvUploadSuccess: false,
  //
  isSearchingManager: false,
  searchManagerList: [],
  //
  imageModal: { open: false },
  //
  isImportingCSV: false,
  importErrList: [],
  isAnalyzingAiImport: false,
  aiImport: null,
  aiImportRejection: null,
  leaveCalcModal: {
    open: false,
    data: {},
  },
  employeeHistory: {},
  employeeHistoryModal: {
    open: false,
  },
  isFetchingBirthdays: false,
  birthdays: [],
  isFetchingDocs: false,
  expiringDocs: {},
  isFetchingEmptyClocks: false,
  emptyClocks: [],
  isFetchingEmptyShifts: false,
  emptyShifts: [],
  //
  searchRotaEmployees: [],
  isSearchingRotaEmployee: false,
  //
  onboardingModalOpen: false,
  //
  isFetchingMatrix: false,
  matrixList: [],
  matrixSteps: [],
  matrixModal: {
    open: false,
  },
  //
  isFetchingMatrixStats: false,
  matrixStats: {},
  //
  isDeletingDocVersion: false,
  //
  isFetchingEmpIndicators: false,
  empIndicators: {},
};

/** The server keeps one import per employee per home, so its reply is the
 *  whole truth about the header chip and the import screen. */
const aiImportFrom = (payload) =>
  payload?.active && payload?.uuid
    ? {
        uuid: payload.uuid,
        status: payload.status,
        filename: payload.filename,
        row_count: payload.row_count,
        message: payload.message || null,
        module: payload.module === "user" ? "user" : "employee",
        active: true,
      }
    : null;

const aiRejectionFrom = (payload) =>
  payload?.rejected
    ? {
        message: payload.message || "This file cannot be imported.",
        filename: payload.filename || null,
      }
    : null;

const EmployeeReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_EMPLOYEE:
        draft.isFetchingEmployee = true;
        break;
      case FETCH_EMPLOYEE_SUCCESS:
        draft.isFetchingEmployee = false;
        draft.employeeList = action.payload;
        break;
      case FETCH_EMPLOYEE_FAILURE:
        draft.isFetchingEmployee = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentEmployee = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentEmployee = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_EMPLOYEE:
        draft.isSubmitting = true;
        break;
      case ADD_EMPLOYEE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_EMPLOYEE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_EMPLOYEE:
        draft.isSubmitting = true;
        break;
      case EDIT_EMPLOYEE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_EMPLOYEE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_EMPLOYEE:
        draft.isDeleting = true;
        break;
      case DELETE_EMPLOYEE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_EMPLOYEE_FAILURE:
        draft.isDeleting = false;
        break;

      case DEFAULT_PERMS:
        draft.defaultPerms = action.payload;
        break;

      case SET_CURRENT_PERMS:
        draft.currentPerms = action.payload;
        break;

      case SEARCH_EMPLOYEE:
        draft.isSearchingEmployee = true;
        draft.searchEmpList = [];
        break;
      case SEARCH_EMPLOYEE_SUCCESS:
        draft.isSearchingEmployee = false;
        draft.searchEmpList = action.payload;
        break;
      case SEARCH_EMPLOYEE_FAILURE:
        draft.isSearchingEmployee = false;
        draft.searchEmpList = [];
        break;

      //
      case SAVE_INFO:
        draft.isSubmitting = true;
        break;
      case SAVE_INFO_SUCCESS:
        draft.isSubmitting = false;
        break;
      case SAVE_INFO_FAILURE:
        draft.isSubmitting = false;
        break;

      //
      case SAVE_DOCS:
        draft.isSavingDocs = true;
        break;
      case SAVE_DOCS_SUCCESS:
        draft.isSavingDocs = false;
        draft.docModal = { open: false };
        break;
      case SAVE_DOCS_FAILURE:
        draft.isSavingDocs = false;
        break;

      //
      case SAVE_SCHEDULE:
        draft.isUpdatingSchedule = true;
        break;
      case SAVE_SCHEDULE_SUCCESS:
        draft.isUpdatingSchedule = false;
        break;
      case SAVE_SCHEDULE_FAILURE:
        draft.isUpdatingSchedule = false;
        break;

      //
      case SEND_INVITE:
        draft.isSendingInvite = true;
        break;
      case SEND_INVITE_SUCCESS:
        draft.isSendingInvite = false;
        break;
      case SEND_INVITE_FAILURE:
        draft.isSendingInvite = false;
        break;

      case TOGGLE_PIN_MODAL:
        draft.pinModal = action.payload;
        break;

      //
      case SAVE_PROFILE:
        draft.isSavingProfile = true;
        break;
      case SAVE_PROFILE_SUCCESS:
        draft.isSavingProfile = false;
        break;
      case SAVE_PROFILE_FAILURE:
        draft.isSavingProfile = false;
        break;

      case TOGGLE_DOC_MODAL:
        draft.docModal = action.payload;
        break;

      //
      case SAVE_PAYROLL:
        draft.isSavingPayroll = true;
        break;
      case SAVE_PAYROLL_SUCCESS:
        draft.isSavingPayroll = false;
        break;
      case SAVE_PAYROLL_FAILURE:
        draft.isSavingPayroll = false;
        break;

      // Delete
      case DELETE_DOC:
        draft.isDeletingDoc = true;
        break;
      case DELETE_DOC_SUCCESS:
        draft.isDeletingDoc = false;
        break;
      case DELETE_DOC_FAILURE:
        draft.isDeletingDoc = false;
        break;

      // Delete
      case SAVE_PIN:
        draft.isSavingPin = true;
        break;
      case SAVE_PIN_SUCCESS:
        draft.isSavingPin = false;
        break;
      case SAVE_PIN_FAILURE:
        draft.isSavingPin = false;
        break;

      case SEND_MAIL:
        draft.isSendingMail = true;
        break;
      case SEND_MAIL_SUCCESS:
        draft.isSendingMail = false;
        break;
      case SEND_MAIL_FAILURE:
        draft.isSendingMail = false;
        break;

      case TOGGLE_MAIL_MODAL:
        draft.mailModal = action.payload;
        break;

      case UPLOAD_CSV:
        draft.isUploadingCSV = true;
        draft.csvUploadSuccess = false;
        break;
      case UPLOAD_CSV_SUCCESS:
        draft.isUploadingCSV = false;
        draft.csvUploadSuccess = true;
        break;
      case UPLOAD_CSV_FAILURE:
        draft.csvUploadSuccess = false;
        draft.isUploadingCSV = false;
        break;

      case SEARCH_MANAGER:
        draft.isSearchingManager = true;
        draft.searchManagerList = [];
        break;
      case SEARCH_MANAGER_SUCCESS:
        draft.isSearchingManager = false;
        draft.searchManagerList = action.payload;
        break;
      case SEARCH_MANAGER_FAILURE:
        draft.isSearchingManager = false;
        draft.searchManagerList = [];
        break;

      case TOGGLE_IMAGE_MODAL:
        draft.imageModal = action.payload;
        break;

      case IMPORT_CSV:
        draft.isImportingCSV = true;
        break;
      case IMPORT_CSV_SUCCESS:
        draft.isImportingCSV = false;
        draft.importErrList = [];
        break;
      case IMPORT_CSV_FAILURE:
        draft.isImportingCSV = false;
        draft.importErrList = action.payload;
        break;

      case ANALYZE_EMPLOYEE_AI_IMPORT:
      case MAP_EMPLOYEE_AI_IMPORT:
        draft.isAnalyzingAiImport = true;
        break;
      case ANALYZE_EMPLOYEE_AI_IMPORT_SUCCESS:
      case FETCH_EMPLOYEE_AI_IMPORT_SUCCESS:
        draft.isAnalyzingAiImport = false;
        draft.aiImport = aiImportFrom(action.payload);
        draft.aiImportRejection = aiRejectionFrom(action.payload);
        break;
      case ANALYZE_EMPLOYEE_AI_IMPORT_FAILURE:
      case MAP_EMPLOYEE_AI_IMPORT_SUCCESS:
      case MAP_EMPLOYEE_AI_IMPORT_FAILURE:
        draft.isAnalyzingAiImport = false;
        break;
      case DISCARD_EMPLOYEE_AI_IMPORT_SUCCESS:
        draft.aiImport = null;
        draft.aiImportRejection = null;
        break;

      case TOGGLE_LEAVE_CALC:
        draft.leaveCalcModal = action.payload;
        break;

      case GET_EMP_HISTORY:
        draft.isFetchingHistory = true;
        draft.employeeHistory = {};
        break;
      case GET_EMP_HISTORY_SUCCESS:
        draft.isFetchingHistory = false;
        draft.employeeHistory = action.payload;
        break;
      case GET_EMP_HISTORY_FAILURE:
        draft.isFetchingHistory = false;
        draft.employeeHistory = {};
        break;

      case TOGGLE_HISTORY_MODAL:
        draft.employeeHistoryModal = action.payload;
        break;

      case GET_BIRTHDAYS:
        draft.isFetchingBirthdays = true;
        draft.birthdays = [];
        break;
      case GET_BIRTHDAYS_SUCCESS:
        draft.isFetchingBirthdays = false;
        draft.birthdays = action.payload;
        break;
      case GET_BIRTHDAYS_FAILURE:
        draft.isFetchingBirthdays = false;
        draft.birthdays = [];
        break;

      case GET_EXPIRING_DOCS:
        draft.isFetchingDocs = true;
        draft.expiringDocs = {};
        break;
      case GET_EXPIRING_DOCS_SUCCESS:
        draft.isFetchingDocs = false;
        draft.expiringDocs = action.payload;
        break;
      case GET_EXPIRING_DOCS_FAILURE:
        draft.isFetchingDocs = false;
        draft.expiringDocs = {};
        break;

      case GET_EMPTY_SHIFTS:
        draft.isFetchingEmptyShifts = true;
        draft.emptyShifts = [];
        break;
      case GET_EMPTY_SHIFTS_SUCCESS:
        draft.isFetchingEmptyShifts = false;
        draft.emptyShifts = action.payload;
        break;
      case GET_EMPTY_SHIFTS_FAILURE:
        draft.isFetchingEmptyShifts = false;
        draft.emptyShifts = [];
        break;

      case GET_EMPTY_CLOCKS:
        draft.isFetchingEmptyClocks = true;
        draft.emptyClocks = [];
        break;
      case GET_EMPTY_CLOCKS_SUCCESS:
        draft.isFetchingEmptyClocks = false;
        draft.emptyClocks = action.payload;
        break;
      case GET_EMPTY_CLOCKS_FAILURE:
        draft.isFetchingEmptyClocks = false;
        draft.emptyClocks = [];
        break;

      case SEARCH_ROTA_EMPLOYEE:
        draft.isSearchingRotaEmployee = true;
        draft.searchRotaEmployees = [];
        break;
      case SEARCH_ROTA_EMPLOYEE_SUCCESS:
        draft.isSearchingRotaEmployee = false;
        draft.searchRotaEmployees = action.payload;
        break;
      case SEARCH_ROTA_EMPLOYEE_FAILURE:
        draft.isSearchingRotaEmployee = false;
        draft.searchRotaEmployees = [];
        break;

      case TOGGLE_ONBOARDING_MODAL:
        draft.onboardingModalOpen = action.payload;
        break;

      case GET_MATRIX:
        draft.isFetchingMatrix = true;
        break;
      case GET_MATRIX_SUCCESS:
        draft.isFetchingMatrix = false;
        draft.matrixList = action.payload;
        break;
      case GET_MATRIX_FAILURE:
        draft.isFetchingMatrix = false;
        draft.matrixList = [];
        break;
      case SET_MATRIX_STEPS:
        draft.matrixSteps = action.payload;
        break;

      case TOGGLE_MATRIX_MODAL:
        draft.matrixModal = action.payload;
        break;

      case GET_MATRIX_STATS:
        draft.isFetchingMatrixStats = true;
        break;
      case GET_MATRIX_STATS_SUCCESS:
        draft.isFetchingMatrixStats = false;
        draft.matrixStats = action.payload;
        break;
      case GET_MATRIX_STATS_FAILURE:
        draft.isFetchingMatrixStats = false;
        draft.matrixStats = {};
        break;
      case DELETE_DOC_VERSION:
        draft.isDeletingDocVersion = true;
        break;
      case DELETE_DOC_VERSION_SUCCESS:
        draft.isDeletingDocVersion = false;
        break;
      case DELETE_DOC_VERSION_FAILURE:
        draft.isDeletingDocVersion = false;
        break;

      case GET_EMP_INDICATORS:
        draft.isFetchingEmpIndicators = true;
        draft.empIndicators = {};
        break;
      case GET_EMP_INDICATORS_SUCCESS:
        draft.isFetchingEmpIndicators = false;
        draft.empIndicators = action.payload;
        break;
      case GET_EMP_INDICATORS_FAILURE:
        draft.isFetchingEmpIndicators = false;
        draft.empIndicators = {};
        break;
      default:
        return state;
    }
  });

export default EmployeeReducer;
